/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export interface DateInfoVO {
  /**
   * day of a date
   */
  day?: number;
  /**
   * hour
   */
  hour?: number;
  /**
   * minute
   */
  minute?: number;
  /**
   * month of a date
   */
  month?: number;
  /**
   * second
   */
  second?: number;
  /**
   * 4-digit year of a date
   */
  year?: number;
}
